import React, { Component } from "react";
import { connect } from "react-redux";
import { toggleView, removeLocation, removeTarget } from "../actions";
import "../styles/Summary.css";
import { formatNumber } from "../lib/utils.js";

const mapStateToProps = (state, ownProps) => {
  return {
    selectedLocations: state.selectedLocations,
    selectedTargets: state.selectedTargets,
    ageRange: state.ageRange,
    totals: state.totals
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    removeTarget: (target, index) => dispatch(removeTarget(target, index)),
    removeLocation: location => dispatch(removeLocation(location)),
    navigateTo: view => dispatch(toggleView(view))
  };
};

class SummaryContainer extends Component {
  render() {
    return (
      <div className="summary__container">
        <h1 className="summary__title">Summary</h1>

        <div className="summary">
          <div className="selection">
            <h2 className="search__label">
              Location
              {" "}
              <a
                className="selection__edit"
                onClick={() => this.props.navigateTo("location")}
              >
                <i className="fa fa-pencil" />
              </a>
            </h2>
            {this.props.selectedLocations.map(location => (
              <div className="summary__option" key={location.key}>
                <p>
                  {location.name +
                    ", " +
                    (location.region || "") +
                    "  (" +
                    location.country_code +
                    ")"}
                </p>
              </div>
            ))}
          </div>

          <div className="selection">
            <h2 className="search__label">
              Target
              {" "}
              <a
                className="selection__edit"
                onClick={() => this.props.navigateTo("target")}
              >
                <i className="fa fa-pencil" />
              </a>
            </h2>
            {this.props.selectedTargets.map((value, index) => (
              <div className="selection__block" key={index}>
                {index !== 0 && <p className="summary__connector">AND</p>}
                {value.map((target, i) => (
                  <div
                    className="summary__option"
                    key={target.id + "-" + index + "-" + i}
                  >
                    <p>
                      {target.name}
                    </p>
                  </div>
                ))}
              </div>
            ))}
          </div>

          <div className="selection">
            <h2 className="search__label">
              Age Range
              <a
                className="selection__edit"
                onClick={() => this.props.navigateTo("age")}
              >
                <i className="fa fa-pencil" />
              </a>
            </h2>
            {this.props.ageRange.map(age => (
              <div className="summary__option" key={age.min + "." + age.max}>
                <p>
                  {age.min} - {age.max}
                </p>

              </div>
            ))}
          </div>
          <div className="selection">
            <h2 className="search__label">
              Total Reach
            </h2>
            <div className="summary__option">
              <p>{formatNumber(this.props.totals)}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const Summary = connect(mapStateToProps, mapDispatchToProps)(SummaryContainer);

export default Summary;



// WEBPACK FOOTER //
// ./src/components/Summary.js